<template>
  <div class="wrapper">
    <div class="main visual-2 doc-appoint-list-main">
      <Header :backRoute="'/'" />

      <div v-if="loading" class="loader">
        <!-- You can replace this with a custom loader or spinner -->
        <div class="spinner"></div>
      </div>

      <div v-else class="doc-appointment-data">
        <!-- Doctor Info, Working Days, and Time Slots -->
        <div class="doctor-overview">
          <div class="box doctor-profile">
            <img
              class="doctor-image"
              :src="doctor?.photo || require('@/assets/img/doctor-james.png')"
              alt="Doctor Profile"
            />
            <div class="doctor-info">
              <h3 class="doctor-name">
                {{ doctor?.firstname + " " + doctor?.lastname }}
              </h3>
              <p class="doctor-address">
                <i class="fa-solid fa-envelope"></i>
                {{ doctor?.email || "N/A" }}
              </p>
              <p class="doctor-address">
                <i class="fa-solid fa-stethoscope"></i>
                {{ doctor?.speciality || "N/A" }}
              </p>
              <p class="doctor-address">
                <i class="fa-solid fa-language"></i>
                {{ doctor?.languagesSpoken?.join(", ") || "N/A" }}
              </p>

              <p class="doctor-address">
                <i class="fa-solid fa-briefcase"></i>
                {{ doctor?.experienceYears }} years experience
              </p>

              <p class="doctor-address">
                <i class="fa-solid fa-venus-mars"></i>
                {{ doctor?.gender || "N/A" }}
              </p>

              <p class="doctor-address">
                <i class="fa-solid fa-location-dot"></i>
                <span>{{
                  doctor?.hospital?.address || "No address provided"
                }}</span>
              </p>
              <p class="doctor-address">
                <i class="fa-solid fa-user"></i>
                {{ doctor?.aboutMe || "No details available" }}
              </p>
            </div>
          </div>
          <div class="box doctor-schedule">
            <div class="schedule-section">
              <h4>Working Days</h4>
              <div class="schedule-days">
                <span
                  v-for="(day, index) in doctor?.timeSlots[0].days"
                  :key="index"
                  class="work-day"
                  :class="{ selected: selectedDay === day.day }"
                  @click="selectedDay = day.day"
                >
                  {{ day.day }}
                </span>
              </div>
            </div>
          </div>
          <div class="box doctor-schedule">
            <div class="schedule-section">
              <h4>Available Time</h4>
              <div class="time-slots">
                <span v-if="filteredSlots?.slots?.length === 0"
                  >No Available Time</span
                >
                <span v-else class="time-slot">
                  {{ convertToLocalTime(filteredSlots.startTime) }} to
                  {{ convertToLocalTime(filteredSlots.endTime) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Appointment Lists (Unchanged) -->
        <!-- <div class="appointments-list">
          <div class="tables-row">
            <div class="box appointments-section">
              <h4>Today Appointment</h4>
              <div class="appointments-table-wrapper"></div>
            </div>

            <div class="box appointments-section">
              <h4>Upcoming Appointment</h4>
              <div class="appointments-table-wrapper"></div>
            </div>
          </div>
        </div> -->
      </div>
      <FooterView />
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { DoctorsService } from "@/services/doctors.service";

// Extend dayjs with UTC and Timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "ViewDoctor",
  data() {
    return {
      doctor: {},
      todayAppointments: [],
      upcomingAppointments: [],
      selectedDay: "Monday", // Track selected working day
      loading: true, // Loader state
    };
  },
  computed: {
    filteredSlots() {
      // Find selected day's slots
      if (!this.selectedDay || !this.doctor?.timeSlots[0].days) return [];
      const dayData = this.doctor?.timeSlots[0].days.find(
        (day) => day.day === this.selectedDay
      );
      return dayData || [];
    },
  },
  methods: {
    formatTime(dateTime) {
      if (!dateTime) return "";

      if (dateTime.includes("T")) {
        // Handle full ISO date-time format
        return dayjs.utc(dateTime).local().format("h:mm A");
      } else {
        // Handle plain time format (e.g., "13:00")
        return dayjs(dateTime, "HH:mm").format("h:mm A");
      }
    },
    convertToLocalTime(utcTime) {
      const now = new Date(); // Get today's date
      const dateString = now.toISOString().split("T")[0]; // Extract YYYY-MM-DD
      const utcDateTime = new Date(`${dateString}T${utcTime}:00Z`); // Create a full ISO string

      return utcDateTime.toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },

    statusClass(status) {
      switch (status) {
        case "open":
          return "status-open";

        case "waiting":
          return "status-waiting";
        case "cancelled":
          return "status-cancelled";
        case "closed":
          return "status-closed";
        case "approved":
          return "status-approved";
        case "started":
          return "status-started";
        case "inprogress":
          return "status-inprogress";
        case "completed":
          return "status-completed";
        default:
          return "status-default"; // For unhandled statuses
      }
    },
  },
  async created() {
    const id = this.$route.params.id;
    if (id) {
      try {
        const response = await DoctorsService.getById(id);
        console.log("🚀 ~ created ~ response:", response.data);
        if (response.success) {
          this.doctor = response.data;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false; // Hide loader after data is fetched
      }
    } else {
      this.$router.push("/hospital-settings");
    }
  },
};
</script>

<style scoped>
.work-day {
  cursor: pointer;
  margin: 0px;
  border-radius: 4px;
  background-color: #f0f0f0;
}

.work-day.selected {
  background-color: #007bff;
  color: white;
}

.time-slot {
  padding: 5px 10px;
  margin: 0px;
  background: #f3f3f3;
  border-radius: 4px;
  display: inline-block;
}

/* Loader Styling */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
